import { render, staticRenderFns } from "./comparTable.vue?vue&type=template&id=1968334a&scoped=true&"
import script from "./comparTable.vue?vue&type=script&lang=js&"
export * from "./comparTable.vue?vue&type=script&lang=js&"
import style0 from "./comparTable.vue?vue&type=style&index=0&id=1968334a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1968334a",
  null
  
)

export default component.exports